import { render, staticRenderFns } from "./ModifierDialog.vue?vue&type=template&id=139a9e6b&"
import script from "./ModifierDialog.vue?vue&type=script&lang=ts&"
export * from "./ModifierDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ModifierDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports